module.exports = __webpack_public_path__ + "static/desktop/img/step-mobile.b2632bf3.png";